<ng-container>
  <h1 class="text-title-4 mb-8" translate>media.registration.registerByEmail.header</h1>
  <p class="text-body-lg mb-24" translate>media.registration.registerByEmail.body</p>
  @if (errorCode !== '') {
    <div class="mb-16">
      <ds-alert
        variant="error"
        [closeLabel]="'rogers.login.popOverClose' | translate"
        (closeClick)="resetErrorCode()"
        role="alert"
        >
        <div class="d-flex flex-column flex-md-row">
          <div class="flex-grow-1 d-flex">
            <ds-icon
              class="mr-8"
              name="error-outlined"
              color="error"
              [ariaHidden]="false"
              caption="Attention"
              [attr.title]="'rogers.login.accessibility.error' | translate"
            ></ds-icon>
            <div>
              @if (errorCode === "ECP5") {
                <p
                  class="text-body mb-0 mw-content"
                  >
                  @if (client === "media") {
                    <span>
                      {{ 'media.errors.' + errorCode | translate }}
                      <a href="javascript:void(0)"
                        variant="cta"
                        class="error-link mb-0 ds-color-link"
                        (click)="signInClick()"
                      > {{'media.errors.signInLink' | translate}}</a>
                    </span>
                  }
                  @if (client === "media_dis") {
                    <span>
                      {{ 'media_dis.errors.' + errorCode | translate }}
                      <a href="javascript:void(0)"
                        variant="cta"
                        class="error-link mb-0 ds-color-link"
                        (click)="signInClick()"
                      > {{'media_dis.errors.signInLink' | translate}}</a>
                    </span>
                  }
                </p>
              } @else {
                <p class="text-body mb-0 mw-content"
                  innerHTML="{{ errorMesageCode | translate }}"
                ></p>
              }
            </div>
          </div>
        </div>
      </ds-alert>
    </div>
  }
  <form [formGroup]="registerForm" (ngSubmit)="validateAndSubmit()"  method="POST" novalidate>
    <div class="mt-16 mb-32">
      <ds-form-field>
        <ds-input-label>{{
          'rogers.registration.registerByEmail.email' | translate
        }}</ds-input-label>
        <input
          dsInput
          type="email"
          [attr.autocorrect]="'off'"
          spellcheck="false"
          autocapitalize="off"
          formControlName="email"
          (keydown.space)="$event.preventDefault()"
          (keydown.enter)="keyDownEnter($event)"
          [attr.aria-required]="true"
          [attr.aria-label]="
          'rogers.registration.registerByEmail.accessibility.email'
            | translate
        "
          [attr.title]="
          'rogers.registration.registerByEmail.accessibility.email'
            | translate
        "
          #emailCreate
          />
          @if (registerForm.invalid  && !invalidEmail &&
            registerForm.get('email').errors.required) {
            <ds-error
              [errorMessage]="'rogers.registration.registerByEmail.error.enterEmail' | translate"
              role="alert"
              class="mt-8"
            ></ds-error>
          }
          @if (registerForm.invalid && invalidEmail) {
            <ds-error
              [errorMessage]="'rogers.registration.registerByEmail.error.validEmail' | translate"
              role="alert"
              class="mt-8"
            ></ds-error>
          }
        </ds-form-field>
        @if (client === "media") {
          <span>
            <p class="text-body-md mb-24 mt-16">
              {{'media.terms' | translate}}
              <a [href]="getPolicyLink()" target="_blank">
              {{'media.privacy' | translate}}</a>
              {{'media.and' | translate}}
              <a [href]="getSportsnetTermsLink()" target="_blank">
              {{'media.policy1' | translate}}</a>
              {{'media.pipe' | translate}}
              <a [href]="getCitytvTermsLink()" target="_blank">
              {{'media.policy2' | translate}}</a>
            </p>
          </span>
        }
        @if (client === "media_dis") {
          <span>
            <p class="text-body-md mb-24 mt-16">
              {{'media_dis.terms' | translate}}
              <a [href]="getPolicyLink()" target="_blank">
              {{'media_dis.privacy' | translate}}</a>
              {{'media_dis.pipe' | translate}}
              <a [href]="getDiscoveryTermsLink()" target="_blank">
              {{'media_dis.and' | translate}} </a>
            </p>
          </span>
        }
      </div>
      <div>
        <button ds-button
          type="submit"
          #submitCreate
          role="button"
          class="w-100 mb-16"
          title="{{ 'common.accessibility.continue' | translate }}">
          @if (!registerInProgress) {
            <span>{{'common.continue' | translate}}</span>
          }
          @if (registerInProgress) {
            <eas-loader class="eas-loader"></eas-loader>
          }
        </button>
        <button ds-button
          variant="secondary"
          type="button"
          class="w-100 mb-48"
          [attr.title]="'common.accessibility.back' | translate"
          (click)="onRegisterskip($event)"
          >
          {{ 'common.back' | translate }}
        </button>
      </div>
    </form>
  </ng-container>

  @if (!blockRecaptcha) {
    <div [class]="recaptchaClass" (outsideClick)="outsideClickCapture()">
      @if (useRecaptchaV3) {
        <re-captcha
          #captchaRefV3="reCaptcha"
          [siteKey]="reCaptchaV3SiteKey"
          size="invisible"
          [badge]="recaptchaBadge"
          [actionName]="'username'"
          (resolved)="$event && processRecaptcha($event)"
        ></re-captcha>
      }
      @if (!useRecaptchaV3) {
        <re-captcha
          #captchaRef="reCaptcha"
          [siteKey]="reCaptchaSiteKey"
          size="invisible"
          [badge]="recaptchaBadge"
          (resolved)="$event && processRecaptcha($event)">
        </re-captcha>
      }
    </div>
  }
